import request from '@/utils/request'

/**
 * 搜索详情列表
 * @param {*} params
 */
export function getProjectRolesList(params) {
  return request({
    url: '/bsProjectRoles',
    method: 'get',
    params: params
  })
}
/**
 * 添加
 * @param {*} params
 */
export function addProjectRoles(params) {
  return request({
    url: '/bsProjectRoles',
    method: 'post',
    data: params
  })
}
/**
 * 修改
 * @param {*} params
 */
export function editProjectRoles(params) {
  return request({
    url: '/bsProjectRoles',
    method: 'put',
    data: params
  })
}
/**
 * 通过id删除
 */
export function deleteProjectRoles(id) {
    return request({
      url: `/bsProjectRoles/${id}`,
      method: 'delete',
    })
  }
  /**
   * 查看详情
   */
  export function getProjectRolesInfo(id) {
    return request({
      url: `/bsProjectRoles/${id}`,
      method: 'get'
    })
  }